import { SimpleCarousel } from '@eventbrite/collection-carousel';
import { LoadingCards } from '@eventbrite/eds-event-card';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import './DatingCarousel.scss';

interface EventLoadingStateProps {
    numberOfEvents?: number;
}

export const EventLoadingState: React.FunctionComponent<
    EventLoadingStateProps
> = (props) => {
    const numberOfEvents =
        typeof props.numberOfEvents === 'number' ? props.numberOfEvents : 4;
    return (
        <div className="dating-carousel">
            <section className="dating-carousel-container__loading">
                <SimpleCarousel
                    headerTitle={
                        <div className="title-subtitle-container">
                            <h2 className="title-loading">
                                {gettext('Date night')}
                            </h2>
                        </div>
                    }
                    slidesVisible={{ desktop: 4, tablet: 2 }}
                    lazilyRenderOffScreenElements={true}
                >
                    {[...Array(numberOfEvents).keys()].map((item: number) => (
                        <div
                            key={`loading_card_${item}`}
                            style={{
                                width: '97%',
                                height: '400px',
                                marginTop: '8px',
                                marginBottom: '8px',
                            }}
                        >
                            <LoadingCards
                                style="grid"
                                dynamicWidth={true}
                                cardCount={1}
                                dynamicHeight={true}
                            />
                        </div>
                    ))}
                </SimpleCarousel>
            </section>
        </div>
    );
};
